/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListTemplatesSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListTemplatesSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListTemplatesSecurity = {
  option1?: ListTemplatesSecurityOption1 | undefined;
  option2?: ListTemplatesSecurityOption2 | undefined;
};

export type ListTemplatesRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListTemplatesSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListTemplatesSecurityOption1$outboundSchema: z.ZodMiniType<
  ListTemplatesSecurityOption1$Outbound,
  ListTemplatesSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listTemplatesSecurityOption1ToJSON(
  listTemplatesSecurityOption1: ListTemplatesSecurityOption1,
): string {
  return JSON.stringify(
    ListTemplatesSecurityOption1$outboundSchema.parse(
      listTemplatesSecurityOption1,
    ),
  );
}

/** @internal */
export type ListTemplatesSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListTemplatesSecurityOption2$outboundSchema: z.ZodMiniType<
  ListTemplatesSecurityOption2$Outbound,
  ListTemplatesSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listTemplatesSecurityOption2ToJSON(
  listTemplatesSecurityOption2: ListTemplatesSecurityOption2,
): string {
  return JSON.stringify(
    ListTemplatesSecurityOption2$outboundSchema.parse(
      listTemplatesSecurityOption2,
    ),
  );
}

/** @internal */
export type ListTemplatesSecurity$Outbound = {
  Option1?: ListTemplatesSecurityOption1$Outbound | undefined;
  Option2?: ListTemplatesSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListTemplatesSecurity$outboundSchema: z.ZodMiniType<
  ListTemplatesSecurity$Outbound,
  ListTemplatesSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListTemplatesSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListTemplatesSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listTemplatesSecurityToJSON(
  listTemplatesSecurity: ListTemplatesSecurity,
): string {
  return JSON.stringify(
    ListTemplatesSecurity$outboundSchema.parse(listTemplatesSecurity),
  );
}

/** @internal */
export type ListTemplatesRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListTemplatesRequest$outboundSchema: z.ZodMiniType<
  ListTemplatesRequest$Outbound,
  ListTemplatesRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listTemplatesRequestToJSON(
  listTemplatesRequest: ListTemplatesRequest,
): string {
  return JSON.stringify(
    ListTemplatesRequest$outboundSchema.parse(listTemplatesRequest),
  );
}
